import { render } from "./SettingsExternalPlugin.vue?vue&type=template&id=7ef9b3ec&scoped=true"
import script from "./SettingsExternalPlugin.vue?vue&type=script&lang=js"
export * from "./SettingsExternalPlugin.vue?vue&type=script&lang=js"

import "./SettingsExternalPlugin.vue?vue&type=style&index=0&id=7ef9b3ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef9b3ec"]])

export default __exports__